export const BE_DOMAIN = process.env.REACT_APP_BE_API_URL;
export const BE_BASE_URL = BE_DOMAIN + '/api';
export const CREATE_NEW_TRANSACTION = '/transactions/upload/transactionFile';
export const UPLOAD_TRANS_BATCH_UPDATES =
  '/transactions/upload/updatedTransactionFile';
export const UPLOAD_INVOICE_BATCH_UPDATES =
  '/invoices/upload/updatedInvoiceFile';
export const UPLOAD_PAYOUT_BATCH_UPDATES = '/payouts/payoutBatchUpdate';
export const UPLOAD_PAYOUT_DOTS_PRE_FAIL = '/payouts/payoutPreFail';
export const session = BE_DOMAIN + '/session';

export const LOCK_MSG = 'System is Locked for any updates';

export default {
  BE_DOMAIN,
  BE_BASE_URL,
  CREATE_NEW_TRANSACTION,
  UPLOAD_TRANS_BATCH_UPDATES,
  UPLOAD_INVOICE_BATCH_UPDATES,
  UPLOAD_PAYOUT_BATCH_UPDATES,
  UPLOAD_PAYOUT_DOTS_PRE_FAIL,
  session,
};
